// src/OtpInput.js
import React, { useState, useEffect } from "react";
import "./OnboardingCustomerInformation.modules.css"; // Import CSS for styling
import { useTranslation } from "react-i18next";
import * as AppUrls from "../../../constants/AppUrls";
import { Redirect } from "react-router-dom";
import NavbarOnboarding from "../NavbarOnboarding/NavbarOnboarding";
import KYCimg from "../../../assets/images/Sharjah/KYC.png";
import i18next from "i18next";
import { useLocation } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as Helpers from "../../../global/Helpers";
import * as utils from "../../../global/utils";
import * as Constants from "../../../constants/Constants";
import SessionExpiredPOPup from "../SessionExpiredPOPup/SessionExpiredPOPup";

const OnboardingCustomerInformation = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const propsEIDinfo = location.state || null;
  const [Nationality, setNationality] = useState([]);
  const [BankAccDetails, setBankAccDetails] = useState([]);
  const [NonSIB, setNonSIB] = useState(false);
  ;
  const [formData, setFormData] = useState({
    firstNameEnglish: propsEIDinfo?.EIDData?.name || "",
    EMIRATES_ID: propsEIDinfo?.EIDData?.EMIRATES_ID || "",
    birthDate: propsEIDinfo?.EIDData?.birthDate || "",
    expiryDate: propsEIDinfo?.EIDData?.expiryDate || "",
    nationality: propsEIDinfo?.EIDData?.nationality || "",
    gender:
      propsEIDinfo?.EIDData?.Gender === "F"
        ? "Female"
        : propsEIDinfo.EIDData.Gender === "M"
        ? "Male"
        : "",
  });

  const [redirect, setRedirect] = useState(null);

  // useEffect(() => {
  //   fetchNationality();
  // }, [i18next.language]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateSubmit()) return;

    var result = Helpers.getScreenIdByGroupAndName("Scan EID");

    var Items = [
      { ID: "6", Value: propsEIDinfo?.EIDData?.Gender },
      { ID: "49", Value: formData.firstNameEnglish },
      { ID: "52", Value: formData.expiryDate },
      { ID: "51", Value: formData.EMIRATES_ID },
      { ID: "4", Value: formData.birthDate },
      { ID: "402", Value: formData.nationality },
      { ID: "288", Value: result?.GROUP_ID || "" },
      { ID: "287", Value: result?.SCREEN_ID || "" },
      // { ID: "7", Value: formData.nationality  },
      { ID: "258", Value: "1" },
    ];
    saveKycData(Items, "");
  };
  const validateSubmit = () => {
    ;
    if (formData.firstNameEnglish === "") {
      Helpers.errorNotify(t("Full name is required"), i18next.language);
      return false;
    }

    if (formData.EMIRATES_ID === "") {
      Helpers.errorNotify(t("Emirates ID is required"), i18next.language);

      return false;
    }

    if (formData.EMIRATES_ID.length > 15 || formData.EMIRATES_ID.length < 15) {
      Helpers.errorNotify(t("Emirates ID must be exactly 15 digits."));

      return false;
    }

    if (formData.birthDate === "") {
      Helpers.errorNotify(t("Birth Date is required"), i18next.language);
      return false;
    }
    if (formData.nationality === "") {
      Helpers.errorNotify(t("Nationality is required"), i18next.language);
      return false;
    }
    if (formData.gender === "") {
      Helpers.errorNotify(t("Gender is required"), i18next.language);
      return false;
    }
    return true;
  };

  const saveKycData = async (Items, RedirectPath) => {
    try {
      if (!validateSubmit(Items[0].Value)) return;

      const body = {
        RequestItems: Items,
        reqID: localStorage.getItem("RID"),
      };
      var response = utils.CallKYCAPI(Constants.GetKYCCibc, body);
      await response
        .then((response) => {
          ;
          if (response.data.Error_code === "0") {
            CallGetBankAccDetails();
            // setRedirect(RedirectPath);
          } else if (response.data.Error_code === "-1") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <SessionExpiredPOPup
                    setRedirect={setRedirect}
                    onClose={onClose}
                  />
                );
              },
            });
          } else {
            Helpers.errorNotify(response.data.Error_Msg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("saveKycData", error);
        });
    } catch (error) {
      console.error("Error posting data saveKycData:", error);
    }
  };
  //   const saveKycData = async (Items) => {
  //     try {
  //       const body = {
  //         RequestItems: Items,
  //         reqID: localStorage.getItem("RID"),
  //       };

  //       var response = utils.CallKYCAPI(Constants.GetKYCCibc, body);
  //       await response
  //         .then((response) => {
  //           ;
  //           if (response.data.Error_code === "0") {
  //             setRedirect(AppUrls.onboardingHome);

  //           } else {
  //             Helpers.errorNotify(response.data.Error_Msg, i18next.language);
  //           }
  //         })
  //         .catch((error) => {
  //           console.log("saveKycData", error);

  //         });
  //     } catch (error) {
  //       console.error("Error posting data saveKycData:", error);
  //     }
  //   };
  const handleChange = (e) => {
    ;
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleBack = (e) => {
    e.preventDefault();
    setRedirect(AppUrls.onboardingPersonal);
  };

  const onclickExistingSIB = (e) => {
    setNonSIB(false);
    setRedirect(AppUrls.AccountSelector);
    // confirmAlert({
    //   customUI: ({ onClose }) => {
    //     return (
    //       <div class="popup-overlay">
    //         <div class="popup-container-KYC">
    //           {/* <h6>{t("investmentAccountMsg")}</h6> */}

    //           <div style={{ fontWeight: "500", textAlign: "start", color: "#0b1d81", fontSize: "1rem" }}>{t("UserConfirmsText")}</div>
    //           <div className="mb-3 mt-3 account-selector">
    //             {/* Account 1 */}
    //             <div className={`account-option ${selectedAccount === "1" ? "selected" : ""}`} onClick={() => handleSelect("1")}>
    //               <input type="radio" id="account-1" name="account" value="1" checked={selectedAccount === "1"} onChange={() => handleSelect("1")} />
    //               <label htmlFor="account-1">Account - **********************123456</label>
    //               {/* <span className="recommended-tag">Recommended</span> */}
    //             </div>

    //             {/* Account 2 */}
    //             <div className={` account-option ${selectedAccount === "2" ? "selected" : ""}`} onClick={() => handleSelect("2")}>
    //               <input type="radio" id="account-2" name="account" value="2" checked={selectedAccount === "2"} onChange={() => handleSelect("2")} />
    //               <label htmlFor="account-2">Account - **********************789101</label>
    //             </div>
    //           </div>

    //           <div style={{ textAlign: "start", fontWeight: "500", color: "#0b1d81", fontSize: "1rem" }}>{t("enterOtherIBAN")}</div>
    //           <div style={{ justifyContent: "space-between", display: "flex" }}>
    //             <input className="mb-3" type="text" id="textIBAN" name="textIBAN" value={IBANValidate} onChange={handleChangeIBAN} style={{ border: "none", margin: "5px", borderBottom: "1px solid #051150", width: "100%" }} required />
    //           </div>
    //           <button
    //             class="yes-button"
    //             onClick={(e) => {
    //               setRedirect(AppUrls.OnboardingNonSIBAccount);
    //               onClose();
    //             }}>
    //             {t("Yes")}
    //           </button>
    //           <button
    //             class="no-button"
    //             onClick={(e) => {
    //               setRedirect(AppUrls.onboardingUserConfirms);
    //               onClose();
    //             }}>
    //             {t("No")}
    //           </button>
    //         </div>
    //       </div>
    //     );
    //   },
    // });
  };

  const onclickNonSIB = (e) => {
    setNonSIB(true);
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div class="popup-overlay">
            <div class="popup-container-KYC">
              <h6>{t("wishOpenAccountSIB")}</h6>
              <button
                class="yes-button"
                onClick={(e) => {
                  ;
                  //onclickExistingSIB(e);
                  window.open(
                    "https://online.sib.ae/index.html?lang=en-US",
                    "_blank"
                  );
                  setRedirect(AppUrls.onboarding);

                  onClose();
                }}
              >
                {t("Yes")}
              </button>
              <button
                class="no-button"
                onClick={(e) => {
                  setNonSIB(true);

                  setRedirect(AppUrls.onboardingUserConfirms);
                  onClose();
                }}
              >
                {t("No")}
              </button>
            </div>
          </div>
        );
      },
    });
  };
  const fetchNationality = async () => {
    try {
      const params = {
        _FormType: "1",
        Lang: i18next.language === "ar" ? "AR" : "EN",
      };
      var response = utils.GetNationalityLookupAPI(params);
      await response
        .then((response) => {
          ;
          if (response.data.ErrorMsg === "success") {
            setNationality(response.data.resData);
          } else if (response.data.ErrorMsg === "Invalid token") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <SessionExpiredPOPup
                    setRedirect={setRedirect}
                    onClose={onClose}
                  />
                );
              },
            });
          } else {
            Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("fetchNationalityApi", error);
        });
    } catch (error) {
      console.log("fetchNationality", error);
    }
  };
  const CallGetBankAccDetails = async () => {
    try {
      const params = {
        ReqID: localStorage.getItem("RID"),
      };
      var response = utils.GetBankAccDetails(params);
      await response
        .then((response) => {
          ;
          if (response.data.ErrorMsg === "success") {
            if (response.data.resData.length !== 0) {
              setBankAccDetails(response.data.resData);
              onclickExistingSIB();
            } else {
              onclickNonSIB();
            }
          } else if (response.data.ErrorMsg === "Invalid token") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <SessionExpiredPOPup
                    setRedirect={setRedirect}
                    onClose={onClose}
                  />
                );
              },
            });
          } else {
            Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("CallGetBankAccDetails", error);
        });
    } catch (error) {
      console.log("CallGetBankAccDetails", error);
    }
  };

  if (redirect !== null) {
    return (
      <Redirect
        to={{
          pathname: redirect,
          state: { NonSIB: NonSIB, BankAccDetails: BankAccDetails },
        }}
      />
    );
    // return <Redirect to={redirect} />;
  }

  return (
    <>
      <NavbarOnboarding />

      <div className="login-main-container">
        <div className="KYCDivImg">
          <h2 className="OpenYourAccountwithUs">{t("OpenYourAccountwithUs")}</h2>
          <img className="KYCImg" src={KYCimg} />
        </div>
        <div className="CustomerInfo-container">
          <div className="CustomerInfo-form">
            <h2 style={{ marginBottom: "2rem" }}>
              {" "}
              {t("CustomerInformation")}
            </h2>

            {/* English Names */}
            <div className="form-group">
              <label>{t("full_name")}</label>
              <input
                type="text"
                name="firstNameEnglish"
                value={formData.firstNameEnglish}
                onChange={handleChange}
                disabled
              />
              {/* {errors.firstNameEnglish && <span className="error">{errors.firstNameEnglish}</span>} */}
            </div>

            <div className="form-group">
              <label>{t("EMIRATES_ID")}</label>
              <input
                type="text"
                name="EMIRATES_ID"
                value={formData.EMIRATES_ID}
                onChange={handleChange}
                disabled
              />
              {/* {errors.firstNameEnglish && <span className="error">{errors.firstNameEnglish}</span>} */}
            </div>

            {/* <div className="form-group">
                  <label>{t("field_second_name_en")}</label>
                  <input type="text" name="secondNameEnglish" value={formData.secondNameEnglish} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>{t("field_third_name_en")}</label>
                  <input type="text" name="thirdNameEnglish" value={formData.thirdNameEnglish} onChange={handleChange} />
                </div> */}
            {/* <div className="form-group">
                  <label>{t("field_last_name_en")}</label>
                  <input type="text" name="lastNameEnglish" value={formData.lastNameEnglish} onChange={handleChange} />
                </div> */}

            {/* Birth Date */}
            <div className="form-group">
              <label>{t("field_date_of_birth")}</label>
              <input
                type="text"
                name="birthDate"
                value={formData.birthDate}
                onChange={handleChange}
                disabled
              />

              {/* <input type="date" name="birthDate" value={formData.birthDate} onChange={handleChange} dateFormat="dd/MM/yyyy" disabled /> */}
              {/* {errors.birthDate && <span className="error">{errors.birthDate}</span>} */}
            </div>
            {/* expiry Date */}
            <div className="form-group">
              <label>{t("ExpiryDate")}</label>
              <input
                type="text"
                name="expiryDate"
                value={formData.expiryDate}
                onChange={handleChange}
                disabled
              />

              {/* <input type="date" name="expiryDate" value={formData.expiryDate} onChange={handleChange} dateFormat="dd/MM/yyyy" disabled /> */}
              {/* {errors.birthDate && <span className="error">{errors.birthDate}</span>} */}
            </div>

            {/* Nationality */}
            {/* <div className="form-group">
              <label>{t("field_nationality")}</label>
              <select id="nationality" name="nationality" value={formData.nationality} onChange={handleChange} disabled>
                {Nationality.map((country, index) => (
                  <option key={index} value={country.value}>
                    {country.NationalityName}
                  </option>
                ))}
              </select>

             {errors.nationality && <span className="error">{errors.nationality}</span>}
            </div> */}

            {/* nationality*/}
            <div className="form-group">
              <label>{t("field_nationality")}</label>
              <input
                type="text"
                name="nationality"
                value={formData.nationality}
                onChange={handleChange}
                disabled
              />
              {/* {errors.firstNameEnglish && <span className="error">{errors.firstNameEnglish}</span>} */}
            </div>

            {/* Gender */}
            {/* <div className="form-group">
              <label>{t("field_gender")}</label>
              <select name="gender" value={formData.gender} onChange={handleChange} disabled>
                <option value="" disabled>
                  {t("Select_Gender")}
                </option>
                <option value="M">Male</option>
                <option value="F">Female </option>
              </select>
              {errors.gender && <span className="error">{errors.gender}</span>} 
            </div> */}

            {/* Gender*/}
            <div className="form-group">
              <label>{t("field_gender")}</label>
              <input
                type="text"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                disabled
              />
              {/* {errors.firstNameEnglish && <span className="error">{errors.firstNameEnglish}</span>} */}
            </div>

            <button
              type="submit"
              className="submit-button mb-2"
              onClick={handleSubmit}
            >
              {t("Confirm")}
            </button>

            <>
              {/* for testing */}
              {/* <button className="submit-button mb-2" onClick={(e) => onclickExistingSIB(e)}>
                {t("ExistingSIB")}
              </button>
              <button className="submit-button mb-2" onClick={(e) => onclickNonSIB(e)}>
                {t("NonSIB")}
              </button> */}
            </>

            <div>
              {/* <button
                className={"link"}
                style={{
                  width: "100%",
                  textDecoration: "underline",
                  marginTop: "1rem",
                  marginLeft: "auto",
                  marginRight: "auto",
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={handleBack}>
                {t("back")}
              </button> */}

              {/* <button className="backBtn" onClick={handleBack}>
                {t("back")}
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OnboardingCustomerInformation;
